export default "__VITE_ASSET__NVLTIuAa__"